import axios from "axios";
import { ip_back } from "../config";
import { readCompetitionClubId } from "../components/funtionsBD/competitionService";

function headers() {
  const token = localStorage.getItem("token") || "";
  return { Authorization: token };
}

function clubParams() {
  const club_id = readCompetitionClubId();
  return club_id ? { club_id } : {};
}

async function request(method, path, { params, data } = {}) {
  try {
    const res = await axios({
      method,
      url: `${String(ip_back || "").replace(/\/?$/, "/")}api/newsletters${path}`,
      headers: headers(),
      params: { ...clubParams(), ...(params || {}) },
      data,
    });
    if (res.data?.status === "error") {
      throw new Error(res.data.message || "Request failed");
    }
    return res.data?.data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || "Request failed";
    const err = new Error(message);
    err.status = error.response?.status || error.status;
    throw err;
  }
}

export function fetchNewsletters() {
  return request("get", "");
}

export function fetchNewsletterIssue(issueId) {
  return request("get", `/${encodeURIComponent(issueId)}`);
}

export function fetchNewsletterCycle() {
  return request("get", "/cycle");
}

export function saveNewsletterCycle(body) {
  return request("put", "/cycle", { data: body });
}

export function previewNewsletter(body) {
  return request("post", "/preview", { data: body });
}

export function closeNewsletterCycle() {
  return request("post", "/close");
}

export function resendNewsletterIssue(issueId) {
  return request("post", `/${encodeURIComponent(issueId)}/resend`, { data: { only_failed: true } });
}

export function fetchNewsletterRecipients() {
  return request("get", "/recipients");
}

export function fetchMailConfig() {
  return request("get", "/mail-config");
}

export function saveMailConfig(body) {
  return request("put", "/mail-config", { data: body });
}

export function deleteMailConfig() {
  return request("delete", "/mail-config");
}

export function testMailConfig() {
  return request("post", "/mail-config/test");
}

export function fetchNewsletterPosts() {
  return request("get", "/posts");
}

export function createNewsletterPost(body) {
  return request("post", "/posts", { data: body });
}

export function updateNewsletterPost(postId, body) {
  return request("put", `/posts/${encodeURIComponent(postId)}`, { data: body });
}

export function deleteNewsletterPost(postId) {
  return request("delete", `/posts/${encodeURIComponent(postId)}`);
}

export function previewNewsletterLink(url) {
  return request("post", "/posts/link-preview", { data: { url } });
}

export function uploadNewsletterImage(file) {
  const form = new FormData();
  form.append("image", file);
  return request("post", "/posts/image", { data: form });
}

export async function fetchPublicNewsletterIssue(issueId, token) {
  try {
    const res = await axios.get(
      `${String(ip_back || "").replace(/\/?$/, "/")}api/public/newsletter/issue/${encodeURIComponent(issueId)}`,
      { params: { t: token } }
    );
    return res.data?.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message || "Request failed");
  }
}
